// extracted by mini-css-extract-plugin
export default {"detail":"Detail_detail__KF8Xv"};